// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreVerifyVendorActionToken = (client) => ({
    /**
     * `POST /store/verify-vendor-action-token`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreVerifyVendorActionTokenCreate
     * @source apps/backend/src/api/store/verify-vendor-action-token/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/verify-vendor-action-token", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=verify-vendor-action-token.js.map